import awLogo from "../../assets/images/aw-logo.svg"
import { LinearProgress, Stack } from "@mui/material"
import Center from "../../components/global/Center"
import { colors } from "../../services/config/colors"

const Loading = () => {
  return (
    <Center style={{ backgroundColor: colors.backgroundWhite }}>
      <Stack gap={1}>
        <img src={awLogo} style={{ width: 120 }} alt="AWorld" />
        <LinearProgress
          style={{
            borderRadius: 120,
          }}
        />
      </Stack>
    </Center>
  )
}

export default Loading
